import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import BootstrapVue3 from 'bootstrap-vue-3'
import store from './vuex/index.js'
import i18n from '../config/language/index'
import withUUID from 'vue-uuid'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import '@babel/polyfill'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import 'flag-icon-css/css/flag-icon.min.css'
import 'font-awesome/css/font-awesome.min.css'
import 'vue3-easy-data-table/dist/style.css'

let app = createApp(App)
app = withUUID(app)
app.use(store)
app.use(router)
app.component('EasyDataTable', Vue3EasyDataTable)
app.use(i18n)

app.use(BootstrapVue3)
app.mount('#app')
